import { Link } from "react-router-dom";
import { ArrowLeft, Plus } from "lucide-react";
import { useTranslation } from "@/shared/providers/LanguageProvider";
import { useToast } from "@/shared/providers/ToastProvider";
import { Breadcrumbs } from "../components/Breadcrumbs";
import { StandardActCodeForm } from "../components/StandardActCodeForm";
import { createAdminMedicalAct } from "../api/adminApi";
import { getAuthToken } from "../auth";
import { createStandardActCode, loadStandardActCodes } from "../standardActCodesStorage";

export function AddStandardActCodePage() {
  const { t } = useTranslation();
  const labels = t.safecheck.acts.standardCodes.create;
  const { showToast } = useToast();

  return (
    <>
      <Breadcrumbs
        items={[
          { label: t.safecheck.nav.acts },
          { label: t.safecheck.acts.standardCodes.title, href: "/dashboard/acts/standard-codes" },
          { label: labels.title },
        ]}
      />

      <div className="mb-4 flex justify-end">
        <Link
          to="/dashboard/acts/standard-codes"
          className="inline-flex items-center gap-2 rounded-lg border border-border bg-card px-3 py-2 text-sm text-muted-foreground transition-colors hover:bg-card-muted"
        >
          <ArrowLeft size={14} />
          {t.safecheck.back}
        </Link>
      </div>

      <div className="theme-card p-6">
        <div className="mb-6 flex items-center gap-2 text-base font-semibold text-foreground">
          <Plus size={16} className="text-primary" />
          {labels.cardTitle}
        </div>

        <StandardActCodeForm
          labels={labels}
          cancelHref="/dashboard/acts/standard-codes"
          onSubmit={async (values) => {
            if (!getAuthToken()) {
              createStandardActCode(loadStandardActCodes(), values);
              showToast(t.actions.saved);
              return;
            }
            await createAdminMedicalAct({
              code: values.code,
              label: values.label,
              category: values.category,
              specialty: values.specialty,
              description: values.description,
            });
            showToast(t.actions.saved);
          }}
        />
      </div>
    </>
  );
}
